import { useContextSelector as useCS } from "use-context-selector"

import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"

export const usePrepareTransactionDictionaries = () => {
  const {
    countries,
    cryptoAssets,
    currencies,
    operations,
    paymentMethods,
    paymentSystemStatuses,
    paymentSystemSubmethods,
    transactionStatuses,
  } = useCS(GlobalConfigContext, globalConfigSelectors.dictionaries)

  if (
    !countries ||
    !cryptoAssets ||
    !currencies ||
    !operations ||
    !paymentMethods ||
    !paymentSystemStatuses ||
    !paymentSystemSubmethods ||
    !transactionStatuses
  ) {
    return {
      dictionaries: null,
      isError: false,
    }
  }

  return {
    dictionaries: {
      countries: countries.data,
      cryptoAssets: cryptoAssets.data,
      currencies: currencies.data,
      operations: operations.data,
      paymentMethods: paymentMethods.data,
      paymentSystemStatuses: paymentSystemStatuses.data,
      paymentSystemSubmethods: paymentSystemSubmethods.data,
      transactionStatuses: transactionStatuses.data,
    },
    isError: !!(
      countries.error ||
      cryptoAssets.error ||
      currencies.error ||
      operations.error ||
      paymentMethods.error ||
      paymentSystemStatuses.error ||
      paymentSystemSubmethods.error ||
      transactionStatuses.error
    ),
  }
}
